import axios from 'axios'
import Vue from 'vue'
import AuthService from "@/service/AuthService";

export default class TeamService {
    authService = new AuthService();
    config = {
        headers: { Authorization: `Bearer ${this.authService.getUserBearerToken()}` }
    };
    getTeams() {
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/getTeamsNames', null, this.config);
    }
    getTeamsData() {
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/GetTeams', null, this.config);
    }
    getTeamData(teamId) {
        const data = {
            TeamId: teamId,
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/GetTeamData', data, this.config);
    }
    getTeam(teamId) {
        const data = {
            TeamId: teamId,
            AdvertisesInfo: false
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/GetTeamInfo', data, this.config);
    }
    updateTeamContacts(teamId, contacts) {
        const data = {
            TeamId: teamId,
            Contacts: contacts
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/UpdateTeamContacts', data, this.config);
    }
    updateTeamToRegistered(teamId, email, password) {
        const data = {
            TeamId: teamId,
            Email: email,
            Password: password
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/UpdateTeamToRegistered', data, this.config);
    }
    updateTeamData(teamData, updateAddress, updateOrgChart, updateImage) {
        const data = {
            TeamData: teamData,
            UpdateAddress: updateAddress,
            UpdateOrgChart: updateOrgChart,
            UpdateImage: updateImage
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/UpdateTeamData', data, this.config);
    }
    updateDefaultOrgChat(teamId, orgChart) {
        const data = {
            TeamId: teamId,
            OrgChart: orgChart
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/UpdateDefaultOrgChart', data, this.config);
    }
    deleteTeam(teamId) {
        const data = {
            TeamId: teamId
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/DeleteTeam', data, this.config);
    }
    addOrUpdatePlayer(teamId, player) {
        const data = {
            TeamId: teamId,
            Player: player
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/AddOrUpdateTeamPlayer', data, this.config);
    }
    getPlayerList(teamId) {
        const data = {
            TeamId: teamId,
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/GetTeamPlayerList', data, this.config);
    }
    deletePlayer(playerId) {
        const data = {
            TeamPlayerId: playerId
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/DeletePlayer', data, this.config);
    }
    saveTeamProfile(team) {
        const data = {
            Team: team
        }
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/SaveTeamInfo', data, this.config);
    }
    getTeamsCount() {
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/GetTeamsCount', null, this.config);
    }
    getTeamPlayers(teamId, teamName) {
        const data = {
            TeamId: teamId,
            TeamName: teamName,
        };
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/GetTeamPlayers', data, this.config);
    }
    getTeamOrgChartContacts(teamId) {
        return axios.post(Vue.prototype.$serviceBaseUrl + '/api/Team/GetTeamOrgChartContacts', null, this.config);
    }
}